<div class="w-100 float-left p-3 light-bg">
    <h6 class="medium mb-0"> {{'filters' | translate }}</h6>
    <div class="form-group mt-2 w-75 d-inline-flex relative">
        <div class="relative w-75">
            <input type="text" class="form-control" readonly *ngIf="this.displayTab=='startProgram'">
            <input type="text" class="form-control" name="emplSearch" (keyup.enter)="populateData('Search')"
                   *ngIf="this.displayTab!='startProgram'" placeholder="{{'enterUserName' | translate}}"
                   [(ngModel)]="searchData.nameOrCodeOrEmail">
            <div ngbTooltip="{{'showSearchOption' | translate}}" placement="bottom-right" class="c-p">
                <i class="fa fa-caret-down tr-0 cursor" (click)="isSearchToggle()"

                   [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"></i>
            </div>
        </div>

        <button class="btn btn-primary" (click)="populateData('Search')"> {{'search' | translate}}</button>
        <div class="w-75 absolute top-100 left-0 p-3 white-bg z-i shadow" id="collapseExample"
             [ngbCollapse]="!isCollapsed">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12" *ngIf="this.displayTab!='startProgram'">
                    <div class="form-group w-100">
                        <label class="medium">{{'userName' | translate}}</label>
                        <input type="text" class="w-100 float-left form-control"
                               placeholder="{{'enterUserName' | translate}}"
                               [(ngModel)]="searchData.nameOrCodeOrEmail" name="nameOrCodeOrEmail" id="userName">
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12" *ngIf="this.displayTab!='startProgram'">
                    <div class="form-group w-100">
                        <label class="medium">{{'icOrPassport' | translate}}</label>
                        <input type="text" class="w-100 float-left form-control"
                               placeholder="{{'enterIcOrPassport' | translate}}"
                               [(ngModel)]="searchData.licenceNumber" name="licenceNumber" id="licenceNumber">
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <button class="btn btn-link float-left" (click)="reset()">{{'resetKey' | translate}}</button>
                    <button class="btn btn-primary float-right ml-3" (click)="isCollapsed = !isCollapsed"
                            [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"
                            (click)="populateData('Search')">{{'apply'
                        | translate}}
                    </button>
                    <button class="btn btn-light float-right" (click)="isCollapsed = !isCollapsed"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="collapseExample">{{'close' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/employee/employeeFilter.html